import type { ReactNode } from 'react'
import { PageInfoBanner } from './PageInfoBanner'
import { cx } from './utils'

export type PageInfoBarProps = {
  message: ReactNode
  actions?: ReactNode
  className?: string
}

/** Γραμμή info + προαιρετικές ενέργειες (π.χ. κουμπί δημιουργίας). */
export function PageInfoBar({ message, actions, className }: PageInfoBarProps) {
  if (!message && !actions) return null

  return (
    <div
      className={cx(
        'flex flex-wrap items-center justify-between gap-3',
        className,
      )}
    >
      {message ? (
        <PageInfoBanner className="min-w-0 flex-1">{message}</PageInfoBanner>
      ) : (
        <div className="min-w-0 flex-1" />
      )}
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
          {actions}
        </div>
      ) : null}
    </div>
  )
}
